import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../../config');

class ModalDetails extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			requested_by:"",
			req_by:"",
			requested_to:"",
			req_to:"",
			observations:"",
			hour:"",
			date_form:"",
			user:"",
			tbl_products:[],
		}
	}

	componentDidMount(){
		this.props.onRef(this);
		
	}

	handleShow(title, id){
		
		this.props.waiting.handleShow('Cargando...');
		
		fetch(Config.default.apiGateway.URL+'plasmatic_product_request/'+id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		}).then(res => {
			this.props.waiting.handleClose();
	    	if(res.ok){
	          	return res.json();
	        }else{
	          	res.text().then(function(result) {
	            	swal('¡Error', result, 'error');
	          	});
        	}
        	
        }).then(response => {
			if(response !== undefined){

				 //obtener usuario
				var user = JSON.parse(sessionStorage.getItem('medical_staff'));

				var name = ""
				if (user.names) {name += user.names};
				if (user.lastname1) {name += ' '+user.lastname1};
				if (user.lastname2) {name += ' '+user.lastname2};

				this.setState({
					user :  name,
					requested_by:sessionStorage.getItem("health_facilities_id"),
					requested_to:response.request.request_to,
			      	hour:moment(response.request.hour, 'H:mm:ss').format('HH:mm'),
			      	status:response.request.status,
			      	date_form : moment(response.request.date).format('YYYY-MM-DD'),
			      	show: true,
					title: title,
					req_by:sessionStorage.getItem('health_facilities_name')
			    });

				for(var i = 0; i < response.detail.length; i++){
					var obj = {
						plasmatic_product_id: response.detail[i].product.id,
						name: response.detail[i].product.name,
						amount:response.detail[i].detail.amount,
						observations: response.detail[i].detail.observations,
						plasmatic_product_request_id:response.detail[i].detail.plasmatic_product_request_id,

					}

					this.setState({ tbl_products: [...this.state.tbl_products, obj]});
				}

				this.getHealthFacilities();
				/*
				var date = new Date(response.unit_request.date);
				

				this.setState({
					user :  name,
					requested_by:response.unit_request.requested_by,
					requested_to:response.unit_request.requested_to,
			      	messenger: response.unit_request.mensajero,
			      	observations: response.unit_request.observaciones,
			      	hour:response.unit_request.hour,
			      	date_form : date.getFullYear()+'-'+("0" + (date.getMonth() + 1)).slice(-2)+'-'+("0" + date.getDate()).slice(-2),
			      	priority: response.unit_request.priority.indexOf('HORAS') !== -1 ? '24 Horas' : 'Urgente',
			      	unitsSolicited:response.unit_request_details,
			      	unitsAsociation:response.units_asociation,
			      	show: true,
					title: title
			    });*/

			    

			   
			}

		})
	}

	getHealthFacilities(){
		//traer hospitales
		fetch(Config.default.apiGateway.URL+'national_centers?option=origin_patients',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({health_facilities:response});
			for (var i = 0; i < response.length; i++) {
				if(response[i].id === this.state.requested_to){
					this.setState({req_to:response[i].name});
				}
			}
		})
	}

	handleClose(){
		this.setState({
			show: false,
			requested_by:"",
			req_by:"",
			requested_to:"",
			req_to:"",
			observations:"",
			hour:"",
			date_form:"",
			user:"",
			tbl_products:[],
		});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{this.state.title}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Centro Distribuidor</span>
		        				<input type="text" className="form-control" value={this.state.req_by} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Centro Peticionario</span>
		        				<input type="text" className="form-control" value={this.state.req_to} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Fecha</span>
		        				<input type="date" className="form-control" value={this.state.date_form} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Hora</span>
		        				<input type="text" className="form-control" value={this.state.hour} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Usuario Solicita</span>
		        				<input type="text" className="form-control" value={this.state.user} disabled/>
		        			</div>
		        		</div>
		        		<div className="col-xs-12">
		        			<fieldset>
			        			<legend>Productos Hemostáticos Solicitados</legend>
			        			<Table responsive hover>
			        				<thead>
					                  	<tr>
						                    <th>Producto</th>
						                    <th>Cantidad</th>
						                    <th>Observaciones</th>
					                  	</tr>
					                </thead>
					                <tbody>
					                 	{this.state.tbl_products.map( (t, index) => (
					                    	<tr key={index}>
					                      		<td>{t.name}</td>
						                      	<td>{t.amount}</td>
						                      	<td>{t.observations}</td>
					                    	</tr>
					                  	))}
					                </tbody>
			        			</Table>
			        		</fieldset>

		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>

		)
	}

} 

export default translate('translations') (ModalDetails);